import React, { useEffect, useState }           from 'react'
// import AnalyticBadRegisters from '../Components/AnalyticBadRegisters'
import ShowNewRegisters                         from '../../Components/ShowNewRegisters'
import axios                                    from 'axios'
import {
   Box,
   Button,
   Container,
   Grid,
   Typography }                                 from '@material-ui/core'
import { CLIENT_PUBLIC_TOKEN }                  from '../../config'
import { node_server }                          from '../../Helpers'
import { store }                                from '../../Redux/Store'
import GetFirstLoginOnly                        from '../Components/GetFirstLoginOnly'
import InfoComponent                            from '../../Components/InfoComponent'

const Analytics = () => {

   const { signedInUsername }                                                       =  store.getState()

   const [ showInfoComponent,                   setShowInfoComponent             ]  =  useState(true)
   const [ totalNumberOfBios,                   setTotalNumberOfBios             ]  =  useState(0)
   const [ totalNumberOfGrads,                  setTotalNumberOfGrads            ]  =  useState(0)
   const [ totalNumberOfRegisteredGrads,        setTotalNumberOfRegisteredGrads  ]  =  useState(0)

   const info = [
      'Clicking on an entry below will reset tbl_auth to pre-login setting',
      'This was put in place for an admin to more easily reset a user when checking',
      'to make sure that their login credentials work prior to sending for registration.'
   ]

   const closeComponent = () => {
      setShowInfoComponent(false)
   }

   /* Total number of grads who have deleted their data from the site using <GradCard /> */
   const [ totalNumberOfDeletedGrads, setTotalNumberOfDeletedGrads ] = useState(0)

   /* 30, 60, 90 day lookback numbers wrt new registrations */
   const [ thirtyDayCount,                setThirtyDayCount                ]  =  useState(0)
   const [ sixtyDayCount,                 setSixtyDayCount                 ]  =  useState(0)
   const [ ninetyDayCount,                setNinetyDayCount                ]  =  useState(0)
   const [ thirtyDayArray,                setThirtyDayArray                ]  =  useState([])
   const [ sixtyDayArray,                 setSixtyDayArray                 ]  =  useState([])
   const [ ninetyDayArray,                setNinetyDayArray                ]  =  useState([])

   /* Booleans to control the showing of 30, 60, 90 day registrations */
   const [ show30Button,                  setShow30Button                  ]  =  useState(true)
   const [ show60Button,                  setShow60Button                  ]  =  useState(true)
   const [ show90Button,                  setShow90Button                  ]  =  useState(true)
   const [ show30Names,                   setShow30Names                   ]  =  useState(true)
   const [ show60Names,                   setShow60Names                   ]  =  useState(true)
   const [ show90Names,                   setShow90Names                   ]  =  useState(true)

   /* Get data from MySQL database
      Total Number of Grads
      Total Number of Registered Grads */
   useEffect( () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.post(node_server + 'admin/analytics', { signedInUsername } )
      .then( res => {
            const { data } = res
            setTotalNumberOfGrads(data.numTotalGrads)
            setTotalNumberOfRegisteredGrads(data.numTotalRegisteredGrads)
            setThirtyDayCount(data.thirtyDayCount)
            setSixtyDayCount(data.sixtyDayCount)
            setNinetyDayCount(data.ninetyDayCount)
            setThirtyDayArray(data.thirtyDayArray)
            setSixtyDayArray(data.sixtyDayArray)
            setNinetyDayArray(data.ninetyDayArray)
            
            /* Set axios headers back to what they were before. This was causing a cors error when calling the PHP server
            after a GET was made to the Node server. */
            axios.defaults.headers.common = {Accept: "application/json, text/plain, */*"}
         } )
   }, [ signedInUsername ] )

   /* Get data from MongoDB database
      Total number of Bios */
   useEffect( () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + 'bio/GetTotalNumberOfBios')
         .then( res => {
            const { data } = res
            setTotalNumberOfBios(data.totalNumberOfBios)

            /* Set axios headers back to what they were before. This was causing a cors error when calling the PHP server
            after a GET was made to the Node server. */
            axios.defaults.headers.common = {Accept: "application/json, text/plain, */*"}
         } )
   }, [] )

      const showThirty = () => {
         setShow30Names(!show30Names)
         setShow60Button(!show60Button)
         setShow90Button(!show90Button)
      }

      const showSixty = () => {
         setShow30Button(!show30Button)
         setShow60Names(!show60Names)
         setShow90Button(!show90Button)
      }

      const showNinety = () => {
         setShow30Button(!show30Button)
         setShow60Button(!show60Button)
         setShow90Names(!show90Names)
      }

   return (
      <Box>
         <Container>
            <Grid style={{marginTop: '5rem'}}>
               <Typography variant='h3'>
                  Analytics
               </Typography>
               <Grid container style={{marginTop: '2rem'}}>

                  <Grid container item xs={12} sm={6} justifyContent='flex-start'>
                     <Typography variant='h5'>
                        Total number of grads: {totalNumberOfGrads}
                     </Typography>
                     <Typography variant='h5'style={{marginTop: '0.5rem'}}>
                        Total number of Registered grads: {totalNumberOfRegisteredGrads} ( {(totalNumberOfRegisteredGrads / totalNumberOfGrads * 100).toFixed(2)}% )
                     </Typography>
                     <Typography variant='h5'style={{marginTop: '0.5rem'}}>
                        Total number of grads with Bios: {totalNumberOfBios} ( {(totalNumberOfBios / totalNumberOfGrads * 100).toFixed(2)}% )
                     </Typography>
                     <Typography variant='h5'style={{marginTop: '0.5rem'}}>
                        % of Registered grads with Bios: {(totalNumberOfBios / totalNumberOfRegisteredGrads * 100).toFixed(2)}%
                     </Typography>
                  </Grid>

                  <Grid container item xs={12} sm={6} justifyContent='flex-start'>
                     <Typography variant='h5'>
                        Number Registered Last 30 Days: {thirtyDayCount}
                     </Typography>
                     <Typography variant='h5'style={{marginTop: '0.5rem'}}>
                        Number Registered Last 60 Days: {sixtyDayCount}
                     </Typography>
                     <Typography variant='h5'style={{marginTop: '0.5rem'}}>
                        Number Registered Last 90 Days: {ninetyDayCount}
                     </Typography>
                     <Grid container item xs={12} sm={6} justifyContent='flex-start'>

                        {show30Button ?
                           <Button variant="contained" color="primary" onClick={showThirty}>
                                 Show 30
                           </Button>
                           :
                           <Button variant="contained" color="primary" disabled>
                                 Show 30
                           </Button>
                        }

                        {show60Button ?
                           <Button variant="contained" color="primary" onClick={showSixty} style={{marginLeft: '0.25rem'}}>
                                 Show 60
                           </Button>
                           :
                           <Button variant="contained" color="primary" disabled style={{marginLeft: '0.25rem'}}>
                                 Show 60
                           </Button>
                        }

                        {show90Button ?
                           <Button variant="contained" color="primary" onClick={showNinety} style={{marginLeft: '0.25rem'}}>
                                 Show 90
                           </Button>
                           :
                           <Button variant="contained" color="primary" disabled style={{marginLeft: '0.25rem'}}>
                                 Show 90
                           </Button>
                        }

                     </Grid>
                  </Grid>

                  {/* <Grid container item xs={12} sm={6} justifyContent='flex-start' style={{marginTop: '1rem'}}>
                     <Typography variant='h5'>
                        Number of Users with More than One Failed Logins: {totalFailedLogins}
                     </Typography>
                  </Grid> */}

                  <Grid container item xs={12} sm={6} justifyContent='flex-start' style={{marginTop: '1rem'}}>
                     <Typography variant='h5'>
                        Number of Users who Deleted their Data: {totalNumberOfDeletedGrads}
                     </Typography>
                  </Grid>

                  <Grid container item xs={12} sm={12} justifyContent='flex-start' style={{marginTop: '1rem'}}>
                  { showInfoComponent ? <InfoComponent closeComponent={closeComponent} info={info} /> : null }
                     <GetFirstLoginOnly closeComponent={closeComponent} />
                  </Grid>

                  {/* {setShowAnalyticBadRegisters ?
                     <AnalyticBadRegisters badUserInfo={badUserInfo} />
                     :
                     null
                  } */}

                  {!show30Names ?
                     <ShowNewRegisters regArray={thirtyDayArray} />
                     :
                     null
                  }

                  {!show60Names ?
                     <ShowNewRegisters regArray={sixtyDayArray} />
                     :
                     null
                  }

                  {!show90Names ?
                     <ShowNewRegisters regArray={ninetyDayArray} />
                     :
                     null
                  }

               </Grid>
            </Grid>
         </Container>
      </Box>
   )
}

export default Analytics